<div class="controls" [hidden]="!showControls()" #controlsElement>
  <ng-container
    *ngTemplateOutlet="
      controlButtonTemplate;
      context: {
        layers: true,
        tooltip: 'layers',
        icon: 'layers-outlined',
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      controlButtonTemplate;
      context: {
        tooltip: 'zoomIn',
        icon: 'zoom-in-outlined',
        click: zoomIn.bind(this),
      }
    "
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="
      controlButtonTemplate;
      context: {
        tooltip: 'zoomOut',
        icon: 'zoom-out-outlined',
        click: zoomOut.bind(this),
      }
    "
  ></ng-container>

  @if (!standalone()) {
    @switch (mode()) {
      @case (OnyxMapMode.MINIMIZED) {
        <ng-container
          *ngTemplateOutlet="
            controlButtonTemplate;
            context: {
              tooltip: 'maximize',
              icon: 'maximize-outlined',
              click: mode.set.bind(this, OnyxMapMode.MAXIMIZED),
            }
          "
        ></ng-container>
      }
      @case (OnyxMapMode.MAXIMIZED) {
        <ng-container
          *ngTemplateOutlet="
            controlButtonTemplate;
            context: {
              tooltip: 'minimize',
              icon: 'minimize-outlined',
              click: mode.set.bind(this, OnyxMapMode.MINIMIZED),
            }
          "
        ></ng-container>
      }
    }
  }
</div>

<ng-template
  let-layers="layers"
  let-tooltip="tooltip"
  let-click="click"
  let-icon="icon"
  #controlButtonTemplate
>
  @let active = layers && layerButtonActive();
  <onyx-icon-button
    [class.active]="active"
    variant="transparent"
    color="black"
    [size]="32"
    [pressed]="active"
    [onyxTooltip]="`${I18N}.${tooltip}`"
    [onyxTooltipPositions]="[OnyxOverlayPosition.LEFT]"
    [onyxTooltipArrowOffsets]="{ y: -4 }"
    [onyxDropdownDisabled]="!layers"
    [onyxDropdownOptions]="LAYER_TYPE_OPTIONS"
    [onyxDropdownValue]="layerType()"
    [(onyxDropdownAttached)]="layerButtonActive"
    [onyxDropdownPositions]="[OnyxOverlayPosition.LEFT]"
    [onyxDropdownOverridePositions]="{ overlayX: 'end' }"
    (onyxDropdownSelectedValueChange)="layerType.set($event.value!)"
    (click)="click?.()"
  >
    <onyx-icon [name]="icon" [size]="16"></onyx-icon
  ></onyx-icon-button>
</ng-template>
